import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  ref: "bcForm",
  class: "p-fluid p-formgrid p-grid p-mt-4 p-mx-2 kn-flex-0"
}
const _hoisted_2 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "desc",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-field p-col-12" }
const _hoisted_9 = { class: "p-float-label " }
const _hoisted_10 = {
  for: "driver",
  class: "kn-material-input-label"
}
const _hoisted_11 = { class: "kn-relative kn-flex" }
const _hoisted_12 = { class: "kn-height-full kn-width-full kn-absolute" }
const _hoisted_13 = { class: "table-header p-d-flex" }
const _hoisted_14 = { class: "p-input-icon-left p-mr-3 p-col-12" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "bsdialog",
    style: _ctx.bsDescriptor.style.bsDialog,
    visible: _ctx.showBusinessClassDialog,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary kn-width-full" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('metaweb.businessModel.newBusiness')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "p-button-text kn-button",
        label: _ctx.$t('common.cancel'),
        onClick: _ctx.closeDialog
      }, null, 8, ["label", "onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        label: _ctx.$t('common.save'),
        disabled: _ctx.buttonDisabled,
        onClick: _ctx.saveBusinessClass
      }, null, 8, ["label", "disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode("form", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InputText, {
              id: "name",
              class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.tmpBusinessModel.name.$invalid && _ctx.v$.tmpBusinessModel.name.$dirty
                        }],
              modelValue: _ctx.v$.tmpBusinessModel.name.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.tmpBusinessModel.name.$model = $event)),
              modelModifiers: { trim: true },
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.tmpBusinessModel.name.$touch())),
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched')))
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.name')) + " *", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            class: "p-mt-1",
            vComp: _ctx.v$.tmpBusinessModel.name,
            additionalTranslateParams: { fieldName: _ctx.$t('common.name') }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_InputText, {
              id: "desc",
              class: "kn-material-input",
              modelValue: _ctx.tmpBusinessModel.description,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.tmpBusinessModel.description = $event))
            }, null, 8, ["modelValue"]),
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('common.description')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("span", _hoisted_9, [
            _createVNode(_component_Dropdown, {
              id: "driver",
              class: "kn-material-input",
              modelValue: _ctx.tmpBusinessModel.physicalModel,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.tmpBusinessModel.physicalModel = $event)),
              filter: true,
              options: _ctx.physicalModels,
              optionLabel: "name"
            }, null, 8, ["modelValue", "options"]),
            _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('metaweb.businessModel.physTable')), 1)
          ])
        ])
      ], 512),
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          (_ctx.tmpBusinessModel.physicalModel)
            ? (_openBlock(), _createBlock(_component_DataTable, {
                key: 0,
                value: _ctx.tmpBusinessModel.physicalModel.columns,
                class: "p-datatable-sm kn-table p-ml-2",
                selection: _ctx.tmpBusinessModel.selectedColumns,
                "onUpdate:selection": _cache[7] || (_cache[7] = ($event: any) => (_ctx.tmpBusinessModel.selectedColumns = $event)),
                scrollable: true,
                scrollHeight: _ctx.bsDescriptor.style.mainList,
                dataKey: "position",
                filters: _ctx.filters,
                "onUpdate:filters": _cache[8] || (_cache[8] = ($event: any) => (_ctx.filters = $event)),
                globalFilterFields: _ctx.bsDescriptor.globalFilterFields
              }, {
                empty: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
                ]),
                header: _withCtx(() => [
                  _createVNode("div", _hoisted_13, [
                    _createVNode("span", _hoisted_14, [
                      _hoisted_15,
                      _createVNode(_component_InputText, {
                        class: "kn-material-input",
                        modelValue: _ctx.filters['global'].value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filters['global'].value = $event)),
                        placeholder: _ctx.$t('common.search')
                      }, null, 8, ["modelValue", "placeholder"])
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, { selectionMode: "multiple" }),
                  _createVNode(_component_Column, {
                    field: "name",
                    header: _ctx.$t('common.name'),
                    style: _ctx.bsDescriptor.style.tableCell
                  }, null, 8, ["header", "style"])
                ]),
                _: 1
              }, 8, ["value", "selection", "scrollHeight", "filters", "globalFilterFields"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}